<template>
  <div class="basket-list" :class="mod">
    <BasketListItem
      v-for="(item,index) in items"
      v-bind:key="index"
      :is-duplicate="highlightDuplicates && isDuplicateRecipe(item)"
      :item="item"
    ></BasketListItem>
    <div class="empty-message" v-if="items.length==0">
      {{ emptyMessage }}
    </div>
  </div>
</template>

<script>

import { mapActions, mapState, mapGetters } from "vuex";

import { basketBase } from "./basketBase";
import BasketListItem from "./BasketListItem";

export default {
  mixins: [ basketBase ],
  components: { BasketListItem },
  props: {
    mod: String,
    highlightDuplicates: Boolean,
    emptyMessage: String
  },
  computed: {
    ...mapState({
        basket: state => state.basket
    }),
  },
  methods: {
    isDuplicateRecipe: function(item) {
      const count = this.basket.items.reduce((a,c)=>{
        return a + (c.recipe.id==item.recipe.id ? 1 : 0)
      },0);
      return count > 1;
    }
  }
};
</script>